import { ComboBox } from '@domgen/base-design-system-2.0/atoms/ComboBox';
import { Input } from '@domgen/base-design-system-2.0/atoms/Input';
import { AutoComplete } from '@domgen/shared/enums/autoComplete';
import { CircleCheck } from '../../../assets/icons/CircleCheck';
import { ModelNumberLocationLink } from '../../../components/ModelNumberLocationLink/ModelNumberLocationLink';
import type { ModelSerialLandingFormProps } from './ModelSerialLandingOnlineForm.types';

const styles = {
  root: 'flex flex-col gap-space-400',
  howToFindModel: 'text-center md:text-left',
};

export function ModelSerialLandingOnlineFormDefault({
  modelNumber,
  serialNumber,
  errors,
  loading,
  modelHintText,
  serialHintText,
  modelOptions,
  waitForSearchError,
  onModelInputChange,
  onModelSelect,
  onSerialChange,
}: ModelSerialLandingFormProps) {
  return (
    <div className={styles.root}>
      <ComboBox
        label="Model number"
        name="modelNumber"
        placeholder="Search for a model number"
        onInputChange={onModelInputChange}
        options={modelOptions}
        defaultValue={modelNumber}
        asyncProps={{ loading }}
        noResultsText="No appliances found"
        hintText={modelHintText}
        required
        onSelect={onModelSelect}
        hasSuccess={!!modelNumber && !errors.modelNumber}
        hasError={
          waitForSearchError && loading
            ? 'Please wait for the search to finish before continuing'
            : errors.modelNumber
        }
        allowCustomValue
        autoComplete={AutoComplete.OFF}
      />
      <Input
        hintText={serialHintText}
        placeholder="Enter a serial number"
        value={serialNumber}
        label="Serial number"
        name="serialNumber"
        onChange={onSerialChange}
        hasSuccess={!!serialNumber && !errors.serialNumber}
        hasError={errors.serialNumber}
        rightIcon={serialNumber && !errors.serialNumber ? <CircleCheck /> : undefined}
        autoComplete={AutoComplete.OFF}
      />
      <ModelNumberLocationLink />
    </div>
  );
}
